import { motion } from "framer-motion";
import { useLang, STR } from "../i18n";

const lineVariants = {
  hidden: { y: "110%" },
  visible: (i) => ({
    y: "0%",
    transition: { duration: 0.9, delay: 0.15 + i * 0.1, ease: [0.16, 1, 0.3, 1] },
  }),
};

const MaskedLine = ({ children, index, className }) => (
  <div className="overflow-hidden">
    <motion.div custom={index} variants={lineVariants} initial="hidden" animate="visible" className={className}>
      {children}
    </motion.div>
  </div>
);

export const Hero = () => {
  const { lang } = useLang();
  const t = STR[lang].hero;

  return (
  <section id="top" className="relative overflow-hidden min-h-[640px] lg:min-h-[720px] flex items-center" data-testid="hero-section">
    <img
      src="/assets/hero-casa.webp"
      alt="Casale in pietra con vista sulle colline — progetto Project Works"
      className="absolute inset-0 w-full h-full object-cover object-center"
      fetchpriority="high"
      data-testid="hero-image"
    />
    <div className="absolute inset-0 bg-white/85 md:hidden" aria-hidden="true" />
    <div
      className="absolute inset-0 bg-[#f8fafb] hidden md:block lg:hidden"
      style={{ clipPath: "polygon(0 0, 60% 0, 75% 100%, 0 100%)" }}
      aria-hidden="true"
    />
    <div
      className="absolute inset-0 bg-[#f8fafb] hidden lg:block"
      style={{ clipPath: "polygon(0 0, 40% 0, 52% 100%, 0 100%)" }}
      aria-hidden="true"
    />
    <div className="relative z-10 max-w-[1320px] mx-auto w-full px-6">
      <span className="hidden md:block absolute left-[85px] top-1/2 -translate-y-1/2 h-[400px] w-[2px] bg-[#0D1B2A]" aria-hidden="true" />
      <span
        className="hidden lg:block absolute left-[57px] top-1/2 text-[10px] tracking-[0.22em] text-[#606c76] uppercase whitespace-nowrap z-10"
        style={{ writingMode: "vertical-rl", transform: "translateY(-50%) rotate(180deg)" }}
        data-testid="hero-side-text"
      >
        {t.side}
      </span>
      <div className="py-[90px] md:pl-[135px] max-w-[720px]">
        <h1 className="font-display uppercase text-[28px] lg:text-[36px] leading-[1.08] tracking-[-0.01em] font-normal text-[#0D1B2A] mb-5">
          <MaskedLine index={1}>
            <span data-testid="hero-title-line-1">{t.l1}</span>
          </MaskedLine>
          <MaskedLine index={2}>
            <span data-testid="hero-title-line-2">{t.l2}</span>
          </MaskedLine>
          <MaskedLine index={3} className="text-[#F18A00]">
            <span data-testid="hero-title-line-3">{t.l3}</span>
          </MaskedLine>
          <MaskedLine index={4} className="text-[#F18A00]">
            <span data-testid="hero-title-line-4">{t.l4}</span>
          </MaskedLine>
        </h1>
        <MaskedLine index={5}>
          <p className="text-[17px] leading-[1.55] text-[#65717a] max-w-[530px] mb-[25px]" data-testid="hero-subtitle">
            {t.sub1}
            <br />
            {t.sub2}
          </p>
        </MaskedLine>
        <MaskedLine index={6}>
          <div>
            <a
              href="#servizi"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector("#servizi")?.scrollIntoView({ behavior: "smooth" });
              }}
              data-testid="hero-cta-button"
              className="inline-flex items-center gap-6 bg-[#0D1B2A] text-white px-[25px] py-[17px] text-xs uppercase tracking-[0.045em] hover:bg-[#F18A00] transition-colors duration-300"
            >
              {t.cta} <span className="text-[21px] font-light leading-none">{"→"}</span>
            </a>
          </div>
        </MaskedLine>
      </div>
    </div>
  </section>
  );
};
